/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'cloud-services';
const componentName = 'verify-cloud-connector-user-host-modal';
const prefix = `${moduleName}.${componentName}`;

export const verifyHostModalTitle = `${prefix}.verifyHostModalTitle`;
export const cleanUpModalTitle = `${prefix}.cleanUpModalTitle`;
export const generalSectionTitle = `${prefix}.generalSectionTitle`;
export const hostIpLabel = `${prefix}.hostIpLabel`;
export const hostIpPlaceholder = `${prefix}.hostIpPlaceholder`;
export const verifyButtonLabel = `${prefix}.verifyButtonLabel`;
export const submitBtnLabel = `${prefix}.submitBtnLabel`;

export const ENGLISH = {
    [verifyHostModalTitle]: 'Verify SSH Credentials with Host',
    [cleanUpModalTitle]: 'Clean up existing Service Engine configuration',
    [generalSectionTitle]: 'General',
    [hostIpLabel]: 'Host IP',
    [hostIpPlaceholder]: 'Enter Host IP',
    [verifyButtonLabel]: 'Verify',
    [submitBtnLabel]: 'Done',
};
